import { render, staticRenderFns } from "./CompanyUrlPrefixField.vue?vue&type=template&id=16aeb9fe"
import script from "./CompanyUrlPrefixField.vue?vue&type=script&lang=js"
export * from "./CompanyUrlPrefixField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports